let elementDom = null;
function resizeWatch (e) {
  if (elementDom) {
    const asideWidth = elementDom.clientWidth;
    var head = document.getElementsByTagName("head")[0];
    let elementStyle = document.querySelector("#dragStyle")
    if (e.clientX > asideWidth - 5 && e.clientX < asideWidth + 5) {
      if (!elementStyle) {
        elementStyle = document.createElement("style");
        elementStyle.id = 'dragStyle'
        elementStyle.type = "text/css";
        try {
          elementStyle.appendChild(document.createTextNode("body{cursor:e-resize}"));
        } catch (ex) {
          elementStyle.styleSheet.cssText = "body{cursor:e-resize}";//针对IE
        }
      }
      head.appendChild(elementStyle);
    } else {
      if (elementStyle) {
        head.removeChild(elementStyle);
      }
    }
  }
};
export default {
  name: 'menuDrag',
  inserted (el, binding, vnode, oldVnode) {
    elementDom = el;
    window.addEventListener("mousemove", resizeWatch, false);
    document.onmousemove = e => { };
    document.onmousedown = e => {
      if (el) {
        const asideWidth = el.clientWidth;
        if (e.clientX > asideWidth - 5 && e.clientX < asideWidth + 5) {
          document.body.onselectstart = function (e) {
            return false;
          };
          const curX = e.clientX;
          document.onmousemove = e => {
            const disX = e.clientX - curX;
            el.style.width =
              asideWidth + disX + "px";
          };
          document.onmouseup = e => {
            document.body.onselectstart = null;
            document.onmousemove = null;
            document.onmouseup = null;
            if (binding.value && binding.value.callback) {
              binding.value.callback()
            }
          };
        }
      }
    };
  },
  componentUpdated: function (el, binding, vnode, oldVnode) {
  },
  unbind (el) {
    window.removeEventListener("mousemove", resizeWatch);
  }
};
